// Libraries
var React = require('react');

// Styles
require('./LiveScores.scss');

class LiveScoresModule extends React.Component {    
    render() {
        return (
            <div className="LiveScores">
                <div className="LiveScores__container">
                    <h2>Live scores</h2>
                    {this.props.results.map((element, index) => {
                        return(
                            <div className="LiveScores__wrapper" key={index}>
                                <p className="LiveScores__hometeam">{element.HomeTeam.Name}</p> 
                                <p className="LiveScores__scores">{element.HomeTeam.Score} <span className="LiveScores__separator">-</span> {element.AwayTeam.Score}</p> 
                                <p className="LiveScores__awayteam">{element.AwayTeam.Name}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
		)
	}
}

module.exports = LiveScoresModule;


// WEBPACK FOOTER //
// ./src/components/MDC/LiveResults/LiveScores/LiveScoresModule.js